import { Column } from 'components/Table/types/column';
import fixFieldEntries from 'data/fix';
import {
  columnDefinitions,
  columns as baseColumns,
  createExecutionColumnFromFixTag,
} from 'routes/Executions/columns';
import { Execution, executionKeyToFixTag, fixMap } from 'types/summaryReport';

export const defaultExecutionFixTags = (): readonly string[] =>
  columnDefinitions
    .map((definition): string => fixMap[definition.key])
    .filter((tag: string): tag is string => tag !== '' && tag in fixFieldEntries);

export const columnKeyToFixTag = (key: keyof Execution | string): string | undefined => {
  const mappedTag = executionKeyToFixTag(key as keyof Execution);
  if (mappedTag !== undefined) {
    return mappedTag;
  }

  const keyAsTag = String(key);
  return keyAsTag in fixFieldEntries ? keyAsTag : undefined;
};

export const columnsToSelectedFixTags = (
  columns: ReadonlyArray<Column<Execution>>
): readonly string[] =>
  columns
    .map((column: Column<Execution>): string | undefined =>
      columnKeyToFixTag(column.key as keyof Execution)
    )
    .filter((tag: string | undefined): tag is string => tag !== undefined);

export const buildExecutionColumnsFromTags = (
  selectedTags: readonly string[]
): Array<Column<Execution>> => {
  const seenKeys = new Set<keyof Execution>();
  const result: Array<Column<Execution>> = [];

  const idColumn = baseColumns.find((column: Column<Execution>): boolean => column.key === 'id');
  if (idColumn !== undefined) {
    result.push(idColumn);
    seenKeys.add('id');
  }

  selectedTags.forEach((tag: string): void => {
    if (!(tag in fixFieldEntries)) {
      return;
    }

    const column = createExecutionColumnFromFixTag(tag);
    if (column === undefined || seenKeys.has(column.key)) {
      return;
    }

    seenKeys.add(column.key);
    result.push(column);
  });

  return result;
};
